var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08745 2.19011L1.52852 5.74905C1.36122 5.91635 1.14829 6 0.889732 6C0.631177 6 0.41825 5.91635 0.250949 5.74905C0.0836492 5.58175 -9.55132e-07 5.36882 -9.09134e-07 5.11026C-8.63137e-07 4.85171 0.0836493 4.63878 0.25095 4.47148L4.44867 0.273765C4.63118 0.0912555 4.8441 8.32411e-07 5.08745 8.74228e-07C5.3308 9.16044e-07 5.54372 0.0912557 5.72623 0.273765L9.92395 4.47148C10.0912 4.63878 10.1749 4.85171 10.1749 5.11027C10.1749 5.36882 10.0912 5.58175 9.92395 5.74905C9.75665 5.91635 9.54372 6 9.28517 6C9.02661 6 8.81368 5.91635 8.64638 5.74905L5.08745 2.19011Z",
    fill: "#1E1531"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowUp);
export default __webpack_public_path__ + "static/media/keyboard-arrow-up.a4e522d9cf4f5e1d853273228d174ec2.svg";
export { ForwardRef as ReactComponent };